export const isVideoLabEnabled = () => import.meta.env.VITE_VIDEO_LAB === true
/** Local diagnostics are a separate loopback-only, development-time surface. */
export function isLocalVideoLabPage(enabled:unknown,hostname:string,routeName:unknown):boolean {
  return enabled===true && ['127.0.0.1','localhost'].includes(hostname) && routeName==='ai-pipeline'
}
